<template>
  <div class="news-banner">
    <el-carousel 
      v-if="bannerList.length > 0"
      ref="bannerRef"
      :interval="currentInterval"
      :pause-on-hover="false"
      trigger="click" 
      height="190px" 
      indicator-position="none"
    >
      <div 
        class="touch-wrapper"
        @touchstart="handleTouchStart"
        @touchend="handleTouchEnd"
        @touchmove.stop
      >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div 
            class="banner-item" 
            :style="`background:url(${proxy.commenUrl}${item}) no-repeat center; background-size: 100% 100%;`"
          >
            <h2 :style="{ color: themeColor }">{{ bannerObject.mc }}</h2>
            <p :style="{ color: themeColor }">{{ bannerObject.js }}</p>
          </div>
        </el-carousel-item>
      </div>
    </el-carousel>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, watch, onBeforeUnmount } from "vue";
import { useRoute } from 'vue-router';

const props = defineProps({
  themeColor: {
    type: String,
    default: '#191919'
  },
  autoInterval: {
    type: Number,
    default: 4000
  }
});

const { proxy } = getCurrentInstance();
const route = useRoute();
const bannerRef = ref(null);

// --- 业务数据逻辑 ---
const bannerObject = ref({});
const bannerList = ref([]);
let path = route.fullPath.split("/")[2] || '';
if (path.indexOf("&") !== -1 && route.path == '/newsList') {
  path = path.split("&")[0];
}

function getArticleList() {
  proxy.$request({
    url: "N_QPSTZX_BANNERTGL_BANNERTGL",
    data: { "ly": path },
    method: "post",
  }).then((res) => {
    if (res.data.code == "000") {
      let result = res.data.result;
      if (result && result.length > 0) {
        bannerObject.value = result[0];
        bannerList.value = bannerObject.value.tp.split(",");
      }
    }
  }).catch((err) => {
    console.log(err);
  });
}

getArticleList();

watch(() => route.fullPath, (newValue) => {
  if (newValue) {
    path = newValue.split("/")[1];
    getArticleList();
  }
});

// --- H5 手势及自动轮播逻辑 ---
const currentInterval = ref(props.autoInterval);
const startX = ref(0);
let recoverTimer = null;

// 手指按下：记录位置并暂停
const handleTouchStart = (e) => {
  startX.value = e.touches[0].clientX;
  
  if (recoverTimer) clearTimeout(recoverTimer);
  currentInterval.value = 0; // 设为0即停止自动轮播
};

// 手指松开：计算滑动并恢复
const handleTouchEnd = (e) => {
  const endX = e.changedTouches[0].clientX;
  const diffX = startX.value - endX;

  // 滑动切换
  if (bannerRef.value && Math.abs(diffX) > 50) {
    if (diffX > 0) {
      bannerRef.value.next();
    } else {
      bannerRef.value.prev();
    }
  }

  // 延迟恢复自动播放，避免瞬间状态切换导致异常
  recoverTimer = setTimeout(() => {
    currentInterval.value = props.autoInterval;
  }, 100);
};

onBeforeUnmount(() => {
  if (recoverTimer) clearTimeout(recoverTimer);
});
</script>

<style lang="less" scoped>
.news-banner {
  width: 100%;
  height: 190px;
  text-align: center;
  padding-top: 0;
  
  // 必须确保手势区域铺满
  .touch-wrapper {
    width: 100%;
    height: 100%;
  }

  .banner-item {
    width: 100%;
    height: 190px;
    -webkit-tap-highlight-color: transparent;
  }

  h2 {
    padding-top: 70px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
  }

  p {
    font-family: AlibabaPuHuiTi_2_55_Regular;
    font-size: 12px;
    line-height: 17px;
  }
}
</style>